import axios from 'axios';
import { constructAuthHeaders } from '@utils/constructAuthHeaders';
import { recommendedLoadsTriggerDatesQuery } from '@utils/recommendedLoadsTriggerQuery';
import { isNull, isUndefined } from 'lodash';
export const getMoreLoads = (baseUrl, companyKey, dotNumber, token) => {
  const headers = constructAuthHeaders(token);
  const url = `${baseUrl}/proxies/companies/${companyKey}/by-carrier/${dotNumber}/trigger-loads`;
  return axios
    .get(url, headers)
    .then(data => {
      return data;
    })
    .catch(err => {
      return err;
    });
};

export const setRecommendedLoadsTriggeredDate_forCompany = (
  firestore,
  dotNumber,
  payload,
) => {
  if (
    isNull(firestore) ||
    isUndefined(firestore) ||
    isNull(dotNumber) ||
    isUndefined(dotNumber) ||
    isNull(payload) ||
    isUndefined(payload) ||
    !firestore.set ||
    typeof firestore.set === 'function'
  ) {
    return;
  }
  firestore
    .set(
      {
        collection: `recommendedLoadsTrigger`,
        doc: dotNumber,
      },
      { ...payload },
      { merge: true },
    )
    .then(() => {
      firestore.get(recommendedLoadsTriggerDatesQuery(dotNumber));
      return true;
    })
    .catch(err => err);
};

export const addLane = (baseUrl, { companyKey, ...payload }, token) => {
  const headers = constructAuthHeaders(token);
  const url = `${baseUrl}/proxies/company/${companyKey}/lanepreferences`;
  return axios
    .post(url, payload, headers)
    .then(data => {
      return data;
    })
    .catch(err => {
      return err;
    });
};
export const addDefaultLane = (
  baseUrl,
  { destination_set, origin_set, ...payload },
  token,
) => {
  const headers = constructAuthHeaders(token);
  const url = `${baseUrl}/searches/global-lane-preferences`;
  return axios
    .post(
      url,
      {
        destination_set_tokens: destination_set,
        origin_set_tokens: origin_set,
        ...payload,
      },
      headers,
    )
    .then(data => {
      return data;
    })
    .catch(err => {
      return err;
    });
};
export const editDefaultLane = (baseUrl, { api_id, ...payload }, token) => {
  const headers = constructAuthHeaders(token);
  const url = `${baseUrl}/searches/global-lane-preferences/${api_id}`;
  return axios
    .patch(
      url,
      {
        ...payload,
      },
      headers,
    )
    .then(data => {
      return data;
    })
    .catch(err => {
      return err;
    });
};
export const deleteDefaultLane = (baseUrl, { api_id }, token) => {
  const headers = constructAuthHeaders(token);
  const url = `${baseUrl}/searches/global-lane-preferences/${api_id}`;
  return axios
    .delete(url, headers)
    .then(data => {
      return data;
    })
    .catch(err => {
      return err;
    });
};
export const notifyLane = (baseUrl, payload, token) => {
  const headers = constructAuthHeaders(token);
  const url = `${baseUrl}/proxies/lane-preference-capacities`;
  return axios
    .post(url, payload, headers)
    .then(data => {
      return data;
    })
    .catch(err => {
      return err;
    });
};

export const getCompanyInfo = (baseUrl, companyKey) => {
  const url = `${baseUrl}/a/companies/${companyKey}/external-detail`;
  return axios.get(url);
};

export const get_isCarrierOndDeck = (baseUrl, companyKey, token) => {
  if (
    isNull(baseUrl) ||
    isUndefined(baseUrl) ||
    isNull(companyKey) ||
    isUndefined(companyKey) ||
    isNull(token) ||
    isUndefined(token)
  ) {
    return Promise.reject(new Error('fail'));
  }
  const headers = constructAuthHeaders(token);
  const url = `${baseUrl}/proxies/companies/${companyKey}/by-carrier`;
  return axios.get(url, headers);
};

export const requestPlatformAccess = (baseUrl, payload, token) => {
  const headers = constructAuthHeaders(token);
  const url = `${baseUrl}/proxies/companies/${payload.external_key}/by-carrier/request`;
  return axios.post(url, payload, headers);
};
